// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RSDbnU_DNqTo2085l8dC {
  text-align: center;
  font-size: smaller;
  user-select: none;
}

.IVNrLQvbTFd7ph0dfUG0 {
  display: inline-flex;
  align-items: center;
  font-weight: bold;
  text-transform: uppercase;
}

.olKg1H5LaBczYCj579IZ {
  cursor: pointer;
  margin-left: 4px;
  display: inline-flex;
  align-items: center;
}

.THiCWp5SVYJtKN3XO_Cn {
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/header/navigation/styles/risk-tolerance-level-indicator.module.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,kBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,eAAA;AAAF","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.indicator {\n  text-align: center;\n  font-size: smaller;\n  user-select: none;\n}\n\n.level {\n  display: inline-flex;\n  align-items: center;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.help_container {\n  cursor: pointer;\n  margin-left: 4px;\n  display: inline-flex;\n  align-items: center;\n}\n\n.help_icon {\n  font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"indicator": `RSDbnU_DNqTo2085l8dC`,
	"level": `IVNrLQvbTFd7ph0dfUG0`,
	"help_container": `olKg1H5LaBczYCj579IZ`,
	"help_icon": `THiCWp5SVYJtKN3XO_Cn`
};
export default ___CSS_LOADER_EXPORT___;
